function getCanvas({ width, height }) {
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    return canvas;
}

const fileToDataURL = (file) => {
    return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onloadend = (e) => resolve((e.target).result)
        reader.readAsDataURL(file)
    })
}
async function loadImage(path) {
    return new Promise((resolve) => {
        const image = new Image();
        image.onload = () => resolve(image)
        image.src = path
    });
}

function getCoordinate(imageData, x, y) {
    return (x + y * imageData.width) * 4;
}

// 转换为灰度图并计算均值
function Rgb2GrayAndGetAverage(imageData) {
    let avg = 0;
    let avgCount = 0;
    for (let left = 0; left < imageData.width; left++) {
        for (let top = 0; top < imageData.height; top++) {
            const coordinate = getCoordinate(imageData, left, top);
            const gray =
                0.299 * imageData.data[coordinate] +
                0.587 * imageData.data[coordinate + 1] +
                0.114 * imageData.data[coordinate + 2];

            // 赋值给 RGB，将彩图转换成灰度图
            imageData.data[coordinate] = gray;
            imageData.data[coordinate + 1] = gray;
            imageData.data[coordinate + 2] = gray;

            // 计算平均值时不包含透明的点
            if (imageData.data[coordinate + 3] !== 0) {
                avg = (avg * avgCount + gray) / (avgCount + 1);
                avgCount++;
            }
        }
    }
    return {
        avg,
    };
}

// 根据阈值获取转换函数
function getColorTransformMatrix({ thresholdWhite, thresholdBlack }) {
    const transformMatrix = Array.from({ length: 256 }); // 色值转换函数
    for (let i = 0; i < 256; i++) {
        if (i > thresholdWhite) {
            transformMatrix[i] = 255; // 白色
        } else if (i < thresholdBlack) {
            transformMatrix[i] = 0; // 黑色
        } else {
            transformMatrix[i] = i; // 保持不变
        }
    }
    return transformMatrix;
}

// 根据色阶转换函数转换图像
function transformColorByMatrix(imageData, transformMatrix) {
    for (let left = 0; left < imageData.width; left++) {
        for (let top = 0; top < imageData.height; top++) {
            const coordinate = getCoordinate(imageData, left, top);
            const gray = transformMatrix[imageData.data[coordinate]];
            imageData.data[coordinate] = gray;
            imageData.data[coordinate + 1] = gray;
            imageData.data[coordinate + 2] = gray;
            // imageData.data[coordinate + 3] = alpha;
        }
    }
}

async function blankCropping(base64) {
    const img = await loadImage(base64);
    var c = document.createElement('canvas');//创建处理画布对象
    var ctx = c.getContext('2d');
    c.width = img.width;
    c.height = img.height;
    ctx.drawImage(img,0,0);//绘制
    var imgData = ctx.getImageData(0, 0, c.width, c.height).data;//读取图片数据
    var lOffset = c.width, rOffset = 0,tOffset = c.height, bOffset = 0;
    for (var i = 0; i < c.width; i++) {
        for (var j = 0; j < c.height; j++) {
            var pos = (i + c.width * j) * 4
            if (imgData[pos] !== 255 || imgData[pos + 1] !== 255 || imgData[pos + 2] !== 255 || imgData[pos + 3] !== 255) {
                bOffset = Math.max(j, bOffset); // 找到有色彩的最下端
                rOffset = Math.max(i, rOffset); // 找到有色彩的最右端
                tOffset = Math.min(j, tOffset); // 找到有色彩的最上端
                lOffset = Math.min(i, lOffset); // 找到有色彩的最左端
            }
        }
    }
    const w = rOffset - lOffset;
    const h = bOffset - tOffset;
    lOffset-= w / 15;
    rOffset+= w / 15;
    tOffset-= h / 15;
    bOffset+= h / 15;
    if(lOffset < 0){
        lOffset = 0;
    }
    if(tOffset < 0){
        tOffset = 0;
    }
    if(rOffset > img.width){
        rOffset = img.width;
    }
    if(bOffset > img.height){
        bOffset = img.height;
    }
    var x = document.createElement("canvas");//创建处理后画布对象
    x.width = rOffset-lOffset;
    x.height = bOffset-tOffset;
    var xx = x.getContext("2d");
    xx.drawImage(img, lOffset, tOffset, x.width, x.height, 0, 0, x.width, x.height);//绘制
    // console.log(lOffset, tOffset, x.width, x.height, x.toDataURL("image/png", 1));//得到最终裁剪出来的base64
    return x.toDataURL("image/png", 1);
}

export async function transformSignatureImage(imagePath) {
    // const base64 = await fileToDataURL(imagePath)
    const img = await loadImage(imagePath);
    const canvas = getCanvas({
        width: img.width,
        height: img.height,
    });
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    const imageData = ctx.getImageData(0, 0, img.width, img.height);

    // 转换为灰度图并计算均值
    const { avg } = Rgb2GrayAndGetAverage(imageData);
    console.log(imageData);

    // 计算阈值
    // 这个应该可以由用户自定义
    const thresholdWhite = avg - 40; // 灰度大于该阈值会变成白色（255，255，255）
    const thresholdBlack = avg - 80; // 灰度低于该阈值会变成纯黑色（0，0，0）

    // 根据阈值获取色阶转换函数
    const transformMatrix = getColorTransformMatrix({
        thresholdWhite,
        thresholdBlack,
    });

    // 根据色阶转换函数转换图像
    transformColorByMatrix(imageData, transformMatrix);

    ctx.putImageData(imageData, 0, 0);
    const dataURL = canvas.toDataURL("image/png", 1);
    const dataURL2 = blankCropping(dataURL);
    return dataURL2;
}